import React, { useEffect, useState } from "react";
import { getCustomStyle } from "../../../api/customAPI";
import NikkiWrapper from "../wrapper/NikkiWrapper";
import "../../../styles/components/selectbook/SelectSteps.scss";
import useAppTranslation from "../../../hooks/useAppTranslation";

export default function SelectDrawType({
  onNext,
  onPrev,
  setDrawType,
  drawType,
  onAlert,
  onSelectSound,
  onNextSound,
  onPrevSound,
}) {
  const { t, language } = useAppTranslation(
    "components/selectbook/selectDrawType",
  );
  const [styleList, setStyleList] = useState([]);

  const getStyleLabel = (item) => {
    const languageCode = language?.split("-")[0];
    return item?.[languageCode] || item?.kr || item?.title || "";
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getCustomStyle();
        if (response.success) {
          setStyleList(response.data.selection_title);
        }
      } catch (error) {
        console.error("Error fetching styles:", error);
      }
    };
    fetchData();
  }, []);

  const handlePrev = () => {
    onPrevSound?.();
    setDrawType("");
    onPrev();
  };

  const handleNext = () => {
    if (!drawType) {
      onAlert(t("alerts.selectDrawType"));
      return;
    }
    onNextSound?.();
    onNext();
  };

  return (
    <NikkiWrapper
      titleDescription={t("titleDescription")}
      progressValue="70"
      onNext={handleNext}
      onPrev={handlePrev}
      showPrev={true}
      onNextSound={onNextSound}
      onPrevSound={onPrevSound}
    >
      <h3>{t("title")}</h3>
      <div className="divider" />
      <ul className="story-list">
        {styleList?.map((item) => {
          const label = getStyleLabel(item);

          return (
            <li
              key={item.kr}
              className={drawType === item.kr ? "action" : ""}
              onClick={() => {
                onSelectSound?.();
                setDrawType((prev) => (prev === item.kr ? "" : item.kr));
              }}
            >
              <figure>
                <img src={item.url} alt={label} />
              </figure>
              <p>{label}</p>
            </li>
          );
        })}
      </ul>
      {styleList.length > 4 && (
        <div className="scroll-indicator">
          <img
            src="/images/makingBranch/arrow-down.svg"
            alt={t("alts.scrollDown")}
          />
          <span>{t("scroll")}</span>
        </div>
      )}
    </NikkiWrapper>
  );
}
